import { apiService } from "./../../app.service";

export const homeApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchMe: builder.query({
      query: () => ({
        url: "/auth/profile",
      }),
      providesTags: ["Me"],
    }),
    fetchSensorList: builder.query({
      query: () => ({
        url: "/user/temperatureSetting/",
      }),
    }),
    fetchSensorSeries: builder.query({
      query: (params) => ({
        url: "/user/average-daily-temperature",
        params,
      }),
    }),
  }),
});

export const {
  useFetchMeQuery,
  useFetchSensorListQuery,
  useFetchSensorSeriesQuery,
} = homeApi;
